<template>
  <div v-if="currentBoNavigationHeadlines && currentBoNavigationHeadlines.length > 0" :class="['headlines-component',
                        {'not-plain': !isplain},
                        {'isplain': isplain},
                        'has-headline',
                        'lines-' + showHeadlinesLines]">

    <div v-if="currentBoNavigationHeadlines && currentBoNavigationHeadlines.length > 0" class="headline-wrapper">
      <template v-if="!isplain">
        <div :class="['headline',
            {'active': headline.idfwheadline === selectedTab.idfwheadline},
            {'not-plain': !isplain}]"
          :key="index"
          v-for="(headline, index) in currentBoNavigationHeadlines"
          :style="setBackground(headline, true)">

          <div class="promo-container" :style="{backgroundImage: 'url(' + headline.imageurl + ')'}">
            <!-- Standard link types -->
            <div class="text-background" v-if="headline.bodytext">
              <div class="promo-content">
                <p class="bodytext" v-html="headline.bodytext"></p>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-if="isplain">
        <div v-if="currentBoNavigationHeadlines && currentBoNavigationHeadlines[0] && currentBoNavigationHeadlines[0].imageurl"
          class="background-image"
          :style="{backgroundImage: 'url(' + currentBoNavigationHeadlines[0].imageurl + ')'}">
        </div>
      </template>
    </div>
  </div>

</template>
<script>
  import store from '@/store'
  import lib from '@/library'

  import BettingOffer from '@/components/mixins/BettingOffer'
  import Screen from '@/components/mixins/Screen'

  export default {
    name: 'headlines',
    props: [
      'category',
      'isplain'
    ],
    mixins: [
      Screen,
      BettingOffer
    ],

    components: {
    },

    data () {
      return {
        selectedTabIdFwHeadline: -1,
        rotationIndex: 0,
        rotationInterval: 5000,
        firstPass: true,
        scrollHorizontalCoordinate: 0,
        circularRotateProgres: false,
        currentidfwheadline: 0
      }
    },

    computed: {
      headlines () {
        return store.getters['cduState/getBoNavigationHeadlines']
      },
      currentBoNavigationHeadlines () {
        return (this.headlines && this.headlines.filter(hl => hl.categoryname === this.category)) || []
      },
      selectedTab () {
        return this.currentBoNavigationHeadlines.filter(item => item.idfwheadline === this.selectedTabIdFwHeadline)[0] ||
          (this.currentBoNavigationHeadlines && this.currentBoNavigationHeadlines.length > 0 && this.currentBoNavigationHeadlines[0]) || undefined
      },
      showHeadlinesLines () {
        return store.getters['bettingOfferState/getShowHeadlinesLines']
      },
      browserName () {
        return lib.core.userAgent.browser.name
      }
    },

    methods: {
      selectTab (idfwheadline) {
        for (let i = 0; i < this.currentBoNavigationHeadlines.length; i++) {
          if (this.currentBoNavigationHeadlines[i].idfwheadline === idfwheadline) {
            this.rotationIndex = i
          }
        }
        this.selectedTabIdFwHeadline = idfwheadline
        this.currentidfwheadline = idfwheadline
      },
      stopRotation () {
        clearTimeout(this.rotate)
        this.rotate = false
      },
      rotateHeadlineCarousel (scrollBack) {
        if (this.currentBoNavigationHeadlines.length > 1 && !this.isplain) {
          this.circularRotateProgres = true
          if (this.rotationIndex > this.currentBoNavigationHeadlines.length - 1 || this.rotationIndex < 0) {
            this.rotationIndex = 0
          }
          this.selectTab(this.currentBoNavigationHeadlines[this.rotationIndex].idfwheadline)
          this.scrollForDevice('pc', scrollBack)
          this.rotationIndex++
          this.rotate = setTimeout(this.rotateHeadlineCarousel, this.rotationInterval)
        }
      },
      setBackground (headline, isForHeadline) {
        // setting gradient + background via JS, not possible with pure CSS
        if (!isForHeadline) {
          let background = 'background: rgb(42,62,86);'
          // active tab/headline is red
          let activeTabBackgroundColor = 'rgb(187,7,42)'
          if (headline && headline.cssclasses) {
            if (headline.cssclasses.toLowerCase().includes('red')) {
              activeTabBackgroundColor = 'rgb(187,7,42)'
            } else if (headline.cssclasses.toLowerCase().includes('green')) {
              activeTabBackgroundColor = 'rgb(65,166,92)'
            } else if (headline.cssclasses.toLowerCase().includes('yellow')) {
              activeTabBackgroundColor = 'rgb(216,133,28)'
            }
          }
          // does headline tab have defined background in prism?
          if (headline.backroundimageurl) {
            // is tab active?
            if (headline.idfwheadline === this.selectedTab.idfwheadline) {
              background = 'background: linear-gradient(45deg, ' + activeTabBackgroundColor + ', transparent), url("' + headline.backroundimageurl + '") center/cover no-repeat !important;'
            } else {
              background = 'background: linear-gradient(0deg, rgba(72,84,102,0.8), rgba(72,84,102,0.8)), url("' + headline.backroundimageurl + '") center/cover no-repeat !important;'
            }
          } else {
            if (headline.idfwheadline === this.selectedTab.idfwheadline) {
              if (this.browserName === 'internet-explorer') {
                background = 'background: linear-gradient(45deg, ' + activeTabBackgroundColor + ', rgb(42,62,86))!important; background-image:none; background-color:rgb(42,62,86);'
              } else {
                background = 'background: linear-gradient(45deg, ' + activeTabBackgroundColor + ', rgb(42,62,86))!important;'
              }
            } else {
              background = 'background: rgb(42,62,86);'
            }
          }
          return background
        }
      },
      scrollForDevice (device, scrollBack) {
        var activeChildWidth = 0
        var parent = {}
        switch (device) {
          case 'mobile':
            if (document.querySelector('.headlines.not-plain')) {
              parent = document.querySelector('.headlines.not-plain')
            }
            if (document.querySelector('.not-plain.headline.active')) {
              activeChildWidth = parent.querySelector('.not-plain.headline.active').offsetWidth
            }
            this.scrollHorizontalCoordinate += activeChildWidth
            // first headline
            if (this.rotationIndex === 0) {
              // move first headline slightly to right
              this.scrollHorizontalCoordinate = 7
              this.setScroll(parent, this.scrollHorizontalCoordinate, 500)
              // then restart to 0
              this.scrollHorizontalCoordinate = 0
            } else if (this.rotationIndex === this.currentBoNavigationHeadlines.length - 1) {
              // last headline
              this.scrollHorizontalCoordinate = this.scrollHorizontalCoordinate + 20
              this.setScroll(parent, this.scrollHorizontalCoordinate, 500)
            } else {
              this.scrollHorizontalCoordinate = this.scrollHorizontalCoordinate + 10
              this.setScroll(parent, this.scrollHorizontalCoordinate - 5, 500)
            }
            break
          case 'tablet':
            if (document.querySelector('.headlines-tabs .tabs__container')) {
              parent = document.querySelector('.headlines-tabs .tabs__container')
            }
            if (parent && parent.querySelector && parent.querySelector('.tabs__div.tab')) {
              activeChildWidth = parent.querySelector('.tabs__div.tab.active').offsetWidth
            }
            if (scrollBack && scrollBack === 'back') {
              this.scrollHorizontalCoordinate -= activeChildWidth
              if (this.rotationIndex === this.currentBoNavigationHeadlines.length - 1) {
                this.scrollHorizontalCoordinate = (this.currentBoNavigationHeadlines.length - 1) * (activeChildWidth + 20)
                this.setScroll(parent, this.scrollHorizontalCoordinate, 500)
              }
              if (this.rotationIndex !== this.currentBoNavigationHeadlines.length - 1 && this.rotationIndex !== 0) {
                this.scrollHorizontalCoordinate = this.scrollHorizontalCoordinate - 20
                this.setScroll(parent, this.scrollHorizontalCoordinate, 500)
              }
              if (this.rotationIndex === 0) {
                this.scrollHorizontalCoordinate = 10
                this.setScroll(parent, this.scrollHorizontalCoordinate, 500)
              }
            }
            if (!scrollBack) {
              this.scrollHorizontalCoordinate += activeChildWidth
              if (this.rotationIndex === 0) {
                this.scrollHorizontalCoordinate = 10
                this.setScroll(parent, this.scrollHorizontalCoordinate, 500)
              }
              if (this.rotationIndex !== this.currentBoNavigationHeadlines.length - 1 && this.rotationIndex !== 0) {
                this.scrollHorizontalCoordinate = this.scrollHorizontalCoordinate + 20
                this.setScroll(parent, this.scrollHorizontalCoordinate, 500)
              }
            }
            break
          case 'pc':
            if (document.querySelector('.headlines-tabs .tabs__container')) {
              parent = document.querySelector('.headlines-tabs .tabs__container')
            }
            if (parent.querySelector('.tabs__div.tab')) {
              activeChildWidth = parent.querySelector('.tabs__div.tab.active').offsetWidth
            }
            if (scrollBack && scrollBack === 'back') {
              this.scrollHorizontalCoordinate -= activeChildWidth
              if (this.rotationIndex === this.currentBoNavigationHeadlines.length - 1) {
                this.scrollHorizontalCoordinate = (this.currentBoNavigationHeadlines.length - 1) * (activeChildWidth + 40)
                this.setScroll(parent, this.scrollHorizontalCoordinate, 500)
              }
              if (this.rotationIndex !== this.currentBoNavigationHeadlines.length - 1 && this.rotationIndex !== 0) {
                this.scrollHorizontalCoordinate = this.scrollHorizontalCoordinate - 40
                this.setScroll(parent, this.scrollHorizontalCoordinate, 500)
              }
              if (this.rotationIndex === 0) {
                this.scrollHorizontalCoordinate = 20
                this.setScroll(parent, this.scrollHorizontalCoordinate, 500)
              }
            }
            if (!scrollBack) {
              this.scrollHorizontalCoordinate += activeChildWidth
              if (this.rotationIndex === 0) {
                this.scrollHorizontalCoordinate = 20
                this.setScroll(parent, this.scrollHorizontalCoordinate, 500)
              }
              if (this.rotationIndex !== this.currentBoNavigationHeadlines.length - 1 && this.rotationIndex !== 0) {
                this.scrollHorizontalCoordinate = this.scrollHorizontalCoordinate + 40
                this.setScroll(parent, this.scrollHorizontalCoordinate, 500)
              }
            }
            break
        }
      },
      setScroll (element, to, duration) {
        var start = element.scrollLeft
        var change = to - start
        var currentTime = 0
        var increment = 20
        var animateScroll = function () {
          currentTime += increment
          var value = this.calculateTime(currentTime, start, change, duration)
          element.scrollLeft = value
          if (currentTime < duration) {
            setTimeout(animateScroll, increment)
          }
        }.bind(this)
        animateScroll()
      },
      calculateTime (currentTime, startTime, chageInTime, duration) {
        currentTime /= duration / 2
        if (currentTime < 1) return chageInTime / 2 * currentTime * currentTime + startTime
        currentTime--
        return -chageInTime / 2 * (currentTime * (currentTime - 2) - 1) + startTime
      },
      tabCssClass (headline) {
        if (headline && headline.cssclasses) {
          var cssClass
          if ((headline.cssclasses.toLowerCase() === 'loggedin') || headline.cssclasses.toLowerCase() === 'loggedout') {
            return
          } else if (headline.cssclasses.toLowerCase().indexOf(' loggedin') > -1) {
            cssClass = headline.cssclasses.replace(' loggedin', '')
            // format to lowercase and concatenate '-color' because of vuetify
            return cssClass.toLowerCase() + '-color loggedin'
          } else if (headline.cssclasses.toLowerCase().indexOf('loggedin ') > -1) {
            cssClass = headline.cssclasses.replace('loggedin ', '')
            // format to lowercase and concatenate '-color' because of vuetify
            return cssClass.toLowerCase() + '-color loggedin'
          } else if (headline.cssclasses.toLowerCase().indexOf(' loggedout') > -1) {
            cssClass = headline.cssclasses.replace(' loggedout', '')
            // format to lowercase and concatenate '-color' because of vuetify
            return cssClass.toLowerCase() + '-color loggedout'
          } else if (headline.cssclasses.toLowerCase().indexOf('loggedout ') > -1) {
            cssClass = headline.cssclasses.replace('loggedout ', '')
            // format to lowercase and concatenate '-color' because of vuetify
            return cssClass.toLowerCase() + '-color loggedout'
          } else {
            cssClass = headline.cssclasses.toLowerCase() + '-color'
          }
          return cssClass || ''
        } else return ''
      },
      // tabCssClass (headline) {
      //   if (headline && headline.cssclasses) {
      //     // format to lowercase and concatenate '-color' because of vuetify
      //     return headline.cssclasses.toLowerCase() + '-color'
      //   } else return ''
      // },
      sleep () {
        return new Promise(resolve => {
          setTimeout(() => {
            resolve()
          }, 100)
        })
      },
      startRotation () {
        this.firstPass = false
        if (!this.mobile) {
          /* little hack for tablet, we have to get specific element from DOM in order to implement auto scroll
          * since element is not rendered yet when in scrollForDevice(), we are w8ing for element to render then start rotation */
          this.sleep().then(this.rotateHeadlineCarousel)
        } else {
          this.rotateHeadlineCarousel()
        }
      }
    },

    mounted () {
      if (this.currentBoNavigationHeadlines.length > 0 && this.firstPass && !this.isplain) {
        this.firstPass = false
        this.rotateHeadlineCarousel()
      }
    },

    destroyed () {
      this.stopRotation()
    },

    watch: {
      currentBoNavigationHeadlines () {
        if (this.currentBoNavigationHeadlines.length > 0 && this.firstPass && !this.isplain) {
          this.startRotation()
        }
        if (this.currentBoNavigationHeadlines.length === 0 && !this.isplain) {
          this.stopRotation()
          this.firstPass = true
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .headlines-component.not-plain.has-headline
    padding: 25px 0 15px
    overflow: hidden;
    clear: both;

    .headline-wrapper.
    .headline
      height: 100%

    .promo-container
      background-repeat: no-repeat
      background-position: center
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      text-align: center
      color: #fff

      .text-background
        background: rgba(0, 0, 0, 0.7)
        padding: 25px

      .promo-title
        margin-bottom: 1.5rem
        font-size: 2.5rem
        font-weight: bold

      .promo-content
        .title
          font-size: 1.6rem
        .bodytext
          font-size: 1.2rem
    // &.lines-6
    //   height 900px
    //   .promo-container .promo-image
    //     height 900px
    //
    // &.lines-5
    //   height 750px
    //   .promo-container .promo-image
    //     height 750px
    //
    // &.lines-4
    //   height 600px
    //   .promo-container .promo-image
    //     height 600px
    //
    // &.lines-3
    //   height 450px
    //   .promo-container .promo-image
    //     height 450px
    //
    // &.lines-2
    //   height 300px
    //   .promo-container .promo-image
    //     height 300px
    //
    &.lines-1
      .text-background
        padding: 10px 25px

  .headlines-component.isplain.has-headline
    position absolute
    top 0
    left 0
    height 100%
    width 100%
    opacity .5
    z-index -1

    .headline-wrapper, .background-image
      height 100%
      width 100%
      background-repeat: no-repeat
      background-position-x center
      background-position-y top
</style>



// WEBPACK FOOTER //
// src/components/cdu/headlines/headlines.vue